import { TreeNode } from "primeng/api";
import { Tubular } from "src/app/wellbore-inputs/components/well-configuration/models";

export class DashboardItemAddedMessage {
    constructor(public widgetIdentifier: string) { }
}

export class GridItemResizedMessage {
    constructor(public name: string, public itemHeight: number, public itemWidth:number) {
      window.dispatchEvent(new Event('resize'));
    }
}

export class ChangeSelectedTubular {
  constructor(public selectedTubular: Tubular) {}
}

export class OpenDesignInNewTab {
    constructor(public treeNode: TreeNode) {}
}
export class ChangeSelectedThermalOperation {
    constructor(public selectedThermalOperation: any) {}
}

export class ChangeSelectedThermalOperationType {
  constructor(public operationType: string) {}
}

export class SyncPressAndTempResults {
    constructor(public syncPressAndTemp: boolean) {}
}

export class DataSavedMessage {
    constructor(public componentInstance: string) {}
}

export class ToggleWellSchematicSidebarMessage {
}

export class OpenSearchComponentDropdown {
}

export class WorkspaceCloned {
  constructor(public designId?: string) {}
}

export class TogglePanelModeMessage {
}

export class PanelModeChangedMessage {
  constructor(public isEnabled: boolean) {}
}

export class ToggleCompactModeMessage {
  constructor(public isEnabled: boolean) {}
}

export class SetPanelColumnsMessage {
  constructor(public columns: number) {}
}

export class CompactModeChangedMessage {
  constructor(public isEnabled: boolean) {}
}

export class ToggleWizardModeMessage {
}

export class WizardModeChangedMessage {
  constructor(public isEnabled: boolean) {}
}

export class WizardStepNavigateMessage {
  constructor(public direction: 'prev' | 'next' | number) {}
}

export class WizardStepChangedMessage {
  constructor(
    public stepIndex: number,
    public totalSteps: number,
    public label: string,
    public labels: readonly string[] = []
  ) {}
}